import { Button } from "@mui/material";
import { KeyboardBackspaceTwoTone } from "@mui/icons-material";

export function BackButton({onClick}: {onClick?: any}) {

    return <Button variant="text" onClick={onClick}>
        <KeyboardBackspaceTwoTone />
        Back
    </Button>
}